import { ArrowRight } from 'lucide-react';

/**
 * Inline alert card shown inside the Request modal (CT-4205) when the typed
 * integration name matches something already connected (Case 1) or already
 * requested by the user (Case 2). Amber "heads-up" tone — advisory, not an
 * error (Case 1 still lets the user submit; Case 2 gates submit via `children`,
 * the "Submit anyway" checkbox). Compact callout, not an empty-state block.
 */
function DuplicateRequestNotice({ icon: Icon, title, actionLabel, onAction, children }) {
  return (
    <div className="mb-[11px] flex gap-2.5 rounded-xl border border-[rgba(217,119,6,0.30)] bg-[rgba(245,158,11,0.10)] p-3 dark:border-[rgba(251,191,36,0.28)] dark:bg-[rgba(251,191,36,0.08)]">
      {Icon ? (
        <Icon
          size={18}
          strokeWidth={1.8}
          aria-hidden="true"
          className="mt-px shrink-0 text-[#B45309] dark:text-[#FBBF24]"
        />
      ) : null}
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <p className="text-[12.5px] font-medium leading-snug text-[#92400E] dark:text-[#FDE68A]">
          {title}
        </p>
        {actionLabel ? (
          <button
            type="button"
            onClick={onAction}
            className="inline-flex items-center gap-1 self-start text-[12px] font-semibold text-[#B45309] transition-colors hover:text-[#92400E] dark:text-[#FCD34D] dark:hover:text-[#FDE68A]"
          >
            {actionLabel}
            <ArrowRight size={13} aria-hidden="true" />
          </button>
        ) : null}
        {children}
      </div>
    </div>
  );
}

export default DuplicateRequestNotice;
